import { Component, OnInit, ChangeDetectorRef, ViewChild, LOCALE_ID } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { AppService } from 'src/app/services/app.service';
import { StateService } from 'src/app/services/states.service';
import { CustomerService } from 'src/app/services/customer.service';
import { MatDialog, MatStepper } from '@angular/material';
import { ShowFileDialog } from '../dialogs-show-file/show-file-dialog.component';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { MessConfirmAbandon } from '../dialogs-messages/mess_confirmabandon_dialog.component';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { InstructionDialog } from '../dialogs-instruction/instruction-dialog.component';
import { DialogCredits } from '../dialog-credits/dialog-credits.component';
import { DialogsErrorsComponent } from '../dialogs-errors/dialogs-errors.component';
import { LoginComponent } from '../../partials/login/login.component';
import { first } from 'rxjs/operators';

import {Title} from "@angular/platform-browser";
import { EntrepriseInfoDialog } from '../dialog-entreprise/dialog-entreprise-info.component';
import { DialogCommonError } from '../dialogs-errors/dialog-common-error.component';
import { Observable, Subject } from 'rxjs';
import { MailService } from 'src/app/services/mail.service';
import { DialogQuestionMessage } from '../dialogs-question/dialog-question-message.component';
import { formatDate } from '@angular/common';
@Component({
  selector: 'app-dossier-add',
  templateUrl: './dossier-add.component.html',
  styleUrls: ['./dossier-add.component.scss']
})
export class DossierAddComponent implements OnInit {
  datedebperiode: any = "";
  datefinperiode: any = "";
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  // thirdFormGroup: FormGroup;
  fourthFormGroup: FormGroup;
  fifthFormGroup: FormGroup;
  sixthFormGroup: FormGroup;
  seventhFormGroup: FormGroup;

  regexSiret = /^[0-9]{14}$/;

  maxSuspPeriodeIndex: number = -1;
  helperOn: boolean = true;
  uploadingFile: boolean = false;
  consumeToken: boolean = true;
  uploadBulletin: boolean = true;
  fichiersCreation: any = [];
  dossierCreationData;
  creationEvent;
  toDelegate: boolean = false;
  fillDelegationForm: boolean = false;

  buttonSiretIsClicked = false;
  siretIsValid = false;
  errorPappers = false;
  entrepriseInfo;
  effectifValues
  effectifTranches;

  bggrey:boolean = false;
  fichiersBS: any = [];
  fichierscomp: any = [];
  dossier: any = "";
  erreur: boolean = false;
  erreurperiode: any = "";
  message: any = [];
  validated: boolean = false;
  calcul: boolean = false;
  strAnciennete: string = '';
  strICL: string = '';
  calculDefaultValues: any = {};
  consolid: boolean = false;
  isCredConsume: string = 'credit';
  codeCoupon:string = '';
  credits: any = [];
  user:any = "";
  waiting: number = 0;
  enteteDoss: any = [];
  map_contrat_statut: any = [];
  map_contrat_motif: any = [];
  contrats: any = [];
  statuts: any = [];
  motifs: any = [];

  duplicate:any = false;
  duplicateID:number = 0;
  origin: any = window.location.origin;
  subscribe: any = [];
  promise:any = [];
  @ViewChild('stepper', {static : true}) private myStepper: MatStepper;
  @ViewChild("svgTogglePostSala", {static : false}) svgTogglePostSala: Component;
  
  currentCalcul: FormControl = new FormControl("");
  BOCC_URL: string = environment.BOCC_URL;
  allstatuts: any;
  allmotifs: any;
  required: any = [];
  dateErr: any = [];
  nbEvent: any;
  dateContSalaFalse: boolean = false;
  dateRuptFalse: boolean = false;
  dateSortieFalse: boolean = false;
  libellAndToolTip: any = [];
  couponId:number = null
  sizemaxFile:number = 4194304; // 4Mo par défaut
  numberToUpload:number = 0;
  numberUploaded:number = 0;
  abonnement:any ={'active_subscription': false};

  filesInError:any = []
  imgs:any =  new Array();
  errorAbbyy: boolean = false;

  errorHandlingMessage:string = ''
  suivantUploadDisabled: boolean = false;

  dateAncienneteBS = "";

  dataFromUploadedFile: object;

  reloadEvent: Subject<any> = new Subject<any>();
  dateParamsForPayslips: any = null;
  isLoading = false;
  hasAtLeastOnePayslip = false;
  isNextButton = false;
  submitToCobham = false;

  nextButtonIsDisabled = false;

  // Variables délégation
  delegationTokenIsValid: boolean = false;
  isDelegationDone: boolean = false;
  delegationToken: string;
  delegationTokenExpirationDate: Date = null;
  delegatedDossier: object;
  company: string;
  clientName: string;
  clientTitle: string;
  titles = {
    "maitre" : "Maître",
    "madame" : "Madame",
    "monsieur" : "Monsieur"
  };
  contractsScreen: boolean = false;
  canStartDelegation: boolean = false;
  delegationData = [];

  documentsDelegation = [];
  reloadDocuments: Subject<any> = new Subject<any>();
  reloadBoolRupture: Subject<any> = new Subject<any>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private appService: AppService,
    private customerService: CustomerService,
    private stateService: StateService,
    private mailService: MailService,
    private httpClient: HttpClient,
    public dialog: MatDialog,
    private cdf: ChangeDetectorRef,
    private router: Router,
    private titleService:Title
    ) {
      this.duplicate = this.activatedRoute.snapshot.params.duplicate;
      this.duplicateID = this.activatedRoute.snapshot.params.displayID ? this.activatedRoute.snapshot.params.displayID.substring(5) : "";
      this.delegationToken = this.activatedRoute.snapshot.params.token;
    }

  errorHandling(response){
      if(response.error){
        this.errorHandlingMessage = response.error
        
        if(response.code == 401){
          let dialogRef = this.dialog.open(LoginComponent, {
            height: '55%',
            width: '25%',
            panelClass:'dialog-login'
          })
        }
      }
  }
  ngOnInit() {
    // this.pload("assets/image/cobham-horloge-opti.gif")
    this.pload("assets/image/cob-gif-attente.gif")
    this.subscribe['sizefilemax'] = this.appService.getSizeFileMax().subscribe((res)=>{
      if(res && res.result){
        this.sizemaxFile = res.result
      }
    })
    this.waiting = environment.waiting;
    this.stateService.user.subscribe((user) => {
      if(user && !this.delegationToken){
        this.user = user;
        this.abonnement = user.abonnement;
        this.customerService.getCredits().subscribe(res=>{
          if (res.result) {
              this.credits = res.result;
            if (!this.credits || !this.credits['next_valid_credit']) {
                this.isCredConsume = "buy-credits";
            }
          }
        });
        this.afterOnInit()
      } else if (this.delegationToken) {
        this.appService.getDossierFromDelegationToken(this.delegationToken).subscribe( (response) => {
          if (response.result.dossier && response.result.token) {
            let result = response.result;
            this.delegationTokenExpirationDate = new Date(response.result.expirationDate);
            environment.tokenauth = result.token;
            environment.tokenDelegation = this.delegationToken;
            this.delegatedDossier = result.dossier;
            this.dossier = result.dossier;
            this.clientName = result.clientName;
            this.company = result.company; 
            this.delegationTokenIsValid = true;

            let currentTitle = "";
            for(const label in this.titles) {
              if (result.clientTitle === label) {
                currentTitle = this.titles[label];
              }
            }
            this.clientTitle = currentTitle;
            
            this.appService.getTokenCalcForDelegation().subscribe( (response) => {
              if (response.result.token_calc) {
                environment.tokencalc = response.result.token_calc;
              }
            })
            this.forceReloadDocuments(this.dossier.id);
            this.afterOnInit()
          } else if (response.result.isDelegationDone) {
              this.myStepper.selectedIndex = 3;
              this.clientName = response.result.clientName;
              this.company = response.result.company; 
              this.submitToCobham = true;
              this.helperOn = false;
          } else {
            this.delegationTokenExpirationDate = new Date(response.result.expirationDate);
            this.cdf.detectChanges();
          }
        })
      } else {
        this.router.navigateByUrl("/dossier");
      }
    });
  }

  afterOnInit(){
    if (this.duplicateID == 0 && this.duplicate == 'false') {
      window['tryga']('send', 'event', 'espace_dossiers', 'creer', '', '');
    }

    this.appService.getParameterPossibleValues(["EFFECT_EMP"]).subscribe((res) => {
        this.effectifValues = res.result["EFFECT_EMP"];
    })

    this.httpClient.get('assets/content-sirene.json?v='+window['cobham_version']).subscribe((res) => {
        this.effectifTranches = res;
    })

    // this.thirdFormGroup = this.formBuilder.group({
    //   NOM_COMPL_SAL: new FormControl(""),
    //   NOM_SAL: new FormControl(""),
    //   PRE_SAL: new FormControl(""),
    //   NIR: new FormControl(""),

    //   NOM_EMP: new FormControl(""),
    //   IDCC: new FormControl(""),
    //   LIB_APE: new FormControl(""),
    //   STATUT: new FormControl(""),
    //   EMPLOI: new FormControl(""),
    //   QUALIF_CC: new FormControl(""),

    //   DT_LAST_BS: new FormControl(""),
    //   DT_DEBUT_CONT:new FormControl(""),
    //   DT_S:new FormControl(""),
    //   TPS_TRAV:new FormControl(""),
    //   CP_APR_PER:new FormControl("")
    // })

    this.fifthFormGroup = this.formBuilder.group({
      calculName: this.currentCalcul,
    });

    /* TODO: Pour l'utilisation des tooltips dans le BOBS, pensez à mettre à jour
     * le tableau arrayCode dans la méthode getLibelleTooltip() de DossierRepository !
     */
    this.subscribe['tooltips'] = this.appService.getLibelleTooltip().subscribe((res)=>{
      if(res && res.result){
        this.libellAndToolTip = res.result
      }
      for(let element in this.libellAndToolTip){
        if(this.libellAndToolTip[element].parameters) {
          this.libellAndToolTip[element].parameters = JSON.parse(this.libellAndToolTip[element].parameters).ListValues
        }
      }
      console.log("libelle / tooltip : ", this.libellAndToolTip)
    })
  
  
    if(this.subscribe && this.subscribe['json']){
      this.subscribe['json'].unsubscribe();
    }
    this.subscribe['json'] = this.httpClient.get('assets/mappage.json?v='+window['cobham_version']).subscribe((res) => {
      this.map_contrat_motif = res["map_contrat_motif"];
      this.map_contrat_statut = res["map_contrat_statut"];

      if(this.subscribe && this.subscribe['json2']){
        this.subscribe['json2'].unsubscribe();
      }
      this.subscribe['json2'] = this.appService.getParameterPossibleValues(["NAT_CONT","STATUT","MOTIF_SORTIE"]).subscribe((res) => {
        this.contrats = res["result"]["NAT_CONT"];
        this.statuts = res["result"]["STATUT"];
        this.allstatuts = res["result"]["STATUT"];
        this.allmotifs = res["result"]["MOTIF_SORTIE"];
        this.motifs = res["result"]["MOTIF_SORTIE"];

        if(this.subscribe && this.subscribe['statedossier'])
          this.subscribe['statedossier'].unsubscribe()
        this.subscribe['statedossier'] = this.stateService.dossier.subscribe((dossier) => {
          if(dossier == "" && this.duplicate=="continue"){
            this.helperOn = false
          }
          console.log("dossier/duplicate/duplicateid", dossier, this.duplicate,this.duplicateID)
          if((dossier == "" && this.duplicate == 'false' && this.duplicateID && this.duplicateID != 0)
            || dossier == "" && this.dossier && this.dossier.id)
          {
            let dossierId = this.dossier.id
            if (!this.dossier)
              dossierId = this.duplicateID;
            this.appService.getDossierById(dossierId).subscribe((data)=>{
              if(data.result.error && data.result.code){
                this.errorHandling(data.result)
              }else if(data && data.result && data.result.datas && data.result.datas[0]){
                dossier = data.result.datas[0]
                if ((dossier.etatDelegation === 1 || dossier.etatDelegation === 2) 
                  && !this.delegationToken) 
                {
                  this.fillDelegationForm = true;
                }
                this.stateService.updateDossier(dossier);
                if (dossier.etatvalidation != -1 && !this.delegationToken)// etatvalidation -1 : dossier créé après achat de crédit mais pas encore initialisé
                  this.myStepper.selectedIndex = 1;
                if (dossier.etatvalidation != -1 && this.delegationToken 
                  && (!this.dossier.bulletinSalaire || this.dossier.bulletinSalaire.length === 0))
                  this.myStepper.selectedIndex = 0;
              }
            })
          } else {
            if(dossier == ""){
              window['tryga']('send', 'event', 'espace_dossiers', 'creer', '', '');
              this.firstFormGroup = this.formBuilder.group({
                  civiliteSala: new FormControl(""),
                  firstnameSala: new FormControl(""),
                  nameSala: new FormControl(""),
                  nameEntSala: new FormControl(""),
                  siret: new FormControl(""),
                  postSala: new FormControl("TRUE"),
                  dateContSala: new FormControl(""),
                  dateContSortieSala: new FormControl(""),
                  //suspSala: new FormControl("FALSE"),
                  statutSala: new FormControl(""),
                  typeSala: new FormControl(""),
                  motifSala: new FormControl(""),
                  maladieSala: new FormControl("FALSE"),
                  dateMaladieSala: new FormControl(""),
                  contRompu: new FormControl("FALSE"),
                  dateRupt: new FormControl(""),
                  nomDateRupt: new FormControl(""),
                  boolRupt: new FormControl("FALSE"),
                  pseudoSalarie: new FormControl(""),
                  pseudoEntreprise: new FormControl(""),
                  isAnonyme: new FormControl("FALSE"),
              })
              this.contrats.forEach(contrat => {
                  if (contrat.Libelle == "CDI") {
                      this.toggleChipContrat(contrat)
                  }
              });
            }
            else if(dossier != "" && this.duplicate == true){
              window['tryga']('send', 'event', 'espace_dossiers', 'dupliquer', '', '');
              this.helperOn = false;
              this.consumeToken = false;
              this.uploadBulletin = false;
              this.dossier = dossier;
              this.firstFormGroup = this.formBuilder.group({
                civiliteSala: new FormControl(dossier.civilite ? dossier.civilite : ""),
                firstnameSala: new FormControl(dossier.prenom ? dossier.prenom : ""),
                nameSala: new FormControl(dossier.nom ? dossier.nom : ""),
                nameEntSala: new FormControl(dossier.entreprise ? dossier.entreprise : ""),
                siret: new FormControl(dossier.siret ? dossier.siret : ""),
                postSala: new FormControl(dossier.poste ? dossier.poste : "TRUE"),
                dateContSala: new FormControl(dossier.datedebut ? dossier.datedebut : null),
                dateContSortieSala: new FormControl(dossier.datesortie ? dossier.datesortie : null),
                //suspSala: new FormControl(dossier.suspendu ? dossier.suspendu : "FALSE"),
                statutSala: new FormControl(dossier.statutsalarie ? dossier.statutsalarie : null),
                typeSala: new FormControl(dossier.typecontrat ? dossier.typecontrat : null),
                motifSala: new FormControl(dossier.motifsortie ? dossier.motifsortie : null),
                maladieSala: new FormControl("FALSE"),
                dateMaladieSala: new FormControl(""),
                contRompu: new FormControl("FALSE"),
                dateRupt: new FormControl(""),
                nomDateRupt: new FormControl(""),
                boolRupt: new FormControl("FALSE"),
                pseudoSalarie: new FormControl(dossier.nom ? dossier.nom : ""),
                pseudoEntreprise: new FormControl(dossier.entreprise ? dossier.entreprise : ""),
                isAnonyme: new FormControl(dossier.isAnonyme ? "TRUE" : "FALSE"),
              });
              //this.initSuspPeriode();
                if (dossier.siret && dossier.siret.toString().match(this.regexSiret) && (this.myStepper._getFocusIndex() == 0)) {
                    this.verifySiren();
                }
                this.initFormWithEntete();
            }else{
              this.helperOn = false;
              this.consumeToken = false;
              this.uploadBulletin = false;
              this.dossier = dossier;
              
              if (dossier.etatvalidation == -1) {// dossier créé après achat de crédit mais pas encore initialisé
                this.helperOn = false;
                this.consumeToken = true;
                this.uploadBulletin = false;
              }

              this.titleService.setTitle("Rupture by Cobham - dossier "+dossier.displayID+ " - "+dossier.prenom+" "+dossier.nom);
              this.firstFormGroup = this.formBuilder.group({
                civiliteSala: new FormControl(dossier.civilite ? dossier.civilite : ""),
                firstnameSala: new FormControl(dossier.prenom ? dossier.prenom : ""),
                nameSala: new FormControl(dossier.nom ? dossier.nom : ""),
                nameEntSala: new FormControl(dossier.entreprise ? dossier.entreprise : ""),
                siret: new FormControl(dossier.siret ? dossier.siret : ""),
                postSala: new FormControl(dossier.poste == "FALSE" || !dossier.poste ? "FALSE" : "TRUE"),
                dateContSala: new FormControl(dossier["datedebut"] ? dossier["datedebut"].toString().split('T')[0] : (dossier.datedebutperiode ?dossier.datedebutperiode.toString().split('T')[0] : "" )),
                dateContSortieSala: (dossier.poste == "FALSE" || !dossier.poste) ? new FormControl(dossier.datesortie ? dossier.datesortie.split('T')[0] : (dossier.datecreation ?dossier.datecreation.split('T')[0] : null)) : new FormControl(""),
                //suspSala: new FormControl((!dossier.suspendu || dossier.suspendu == "FALSE") ? "FALSE" : "TRUE"),
                typeSala: new FormControl(dossier.typecontrat ? dossier.typecontrat : ""),
                statutSala: new FormControl(dossier.statutsalarie ? dossier.statutsalarie : ""),
                motifSala: new FormControl(dossier.motifsortie ? dossier.motifsortie : ""),
                maladieSala: new FormControl("FALSE"),
                dateMaladieSala: new FormControl(""),
                contRompu: new FormControl("FALSE"),
                dateRupt: new FormControl(""),
                nomDateRupt: new FormControl(""),
                boolRupt: new FormControl("FALSE"),
                pseudoSalarie: new FormControl(dossier.nom ? dossier.nom : ""),
                pseudoEntreprise: new FormControl(dossier.entreprise ? dossier.entreprise : ""),
                isAnonyme: new FormControl(dossier.isAnonyme ? "TRUE" : "FALSE"),
              });

              if (dossier.siret && dossier.siret.toString().match(this.regexSiret) && (this.myStepper._getFocusIndex() == 0)) {
                  this.verifySiren();
              }
              this.triBulletin(dossier);
              this.contrats.forEach((element)=> {
                if(element.Value == this.firstFormGroup.get("typeSala").value){
                  let replaceStatuts = this.allstatuts.map(statut => {
                    if (this.map_contrat_statut.hasOwnProperty(element.value) && this.map_contrat_statut[element.value].includes(statut.Value))
                      statut['actif'] = true;
                    else 
                      statut['actif'] = false;
                    return statut;
                  });
                  this.statuts = replaceStatuts;
                  this.toggleChipContrat(element)
                  if(dossier.statutsalarie){
                    let stat = this.statuts.find(el => el.Value == dossier.statutsalarie )
                    this.toggleChip(stat)
                  }
                }
              });
              
              this.motifs.forEach((element)=> {
                if(element.Value == dossier.motifsortie){
                  this.toggleChipMotif(element)
                }
              });

              if (this.delegationToken && this.myStepper._getFocusIndex() == 0 
                && (!this.dossier.bulletinSalaire || this.dossier.bulletinSalaire.length === 0))
              {
                this.helperOn = true;
                this.consumeToken = true;
              } else if (this.myStepper._getFocusIndex() === 0) {
                  this.myStepper.selectedIndex = 1;
              }

              if(this.subscribe && this.subscribe['entetesdoss']){
                this.subscribe['entetesdoss'].unsubscribe();
              }
              this.subscribe['entetesdoss'] =this.appService.getDossierEntete(this.dossier.id).subscribe((res) => {
                if (res.result) {
                  this.dossier.entete = res.result.entete;
                  res.result.entete.forEach(entete => {

                    if(entete.parametre && entete.parametre.code && entete.value){
                      this.enteteDoss[entete.parametre.code] = entete.value; 
                    }
                    if(entete.parametre && entete.parametre.code && entete.valueint){
                      this.enteteDoss[entete.parametre.code] = entete.valueint; 
                    }
                    if(entete.parametre && entete.parametre.code && entete.valuedate){
                      this.enteteDoss[entete.parametre.code] = entete.valuedate; 
                    }
                  });

                  this.forceReloadBoolRupture(this.enteteDoss["BOOL_RUPT"]);

                  // Affectation de l'unité de temps (converti en toute lettres) au temps de travail
                  let example = {
                    "HS": "heures/semaine",
                    "HM": "heures/mois",
                    "HA": "heures/an",
                    "JM": "jours/mois",
                    "JA": "jours/an",
                    "null": "heures/mois",
                    "undefined": "heures/mois"
                  }
                  let uniteTempsTravail = this.enteteDoss.TPS_TRAV_UNIT;
                  if (this.enteteDoss.TPS_TRAV) {
                    this.enteteDoss.TPS_TRAV = Math.round(this.enteteDoss.TPS_TRAV*100)/100;
                    if(example[uniteTempsTravail])
                      this.enteteDoss.TPS_TRAV += " "+example[uniteTempsTravail];
                    else
                      this.enteteDoss.TPS_TRAV += " "+uniteTempsTravail;
                  }

                  this.computeStrCalculResult();
                  //this.initSuspPeriode();
                  this.initFormWithEntete();
                  this.canStartDelegation = true;

                  this.appService.getDatePeriode(
                      this.firstFormGroup.get("dateContSala").value, 
                      this.firstFormGroup.get("postSala").value, 
                      this.firstFormGroup.get("dateContSortieSala").value, 
                      this.firstFormGroup.get("motifSala").value, 
                      this.firstFormGroup.get("dateRupt").value, 
                      this.firstFormGroup.get("maladieSala").value, 
                      this.firstFormGroup.get("dateMaladieSala").value).subscribe((res) => {
                    if (res.result && res.result.datedeb)
                      this.datedebperiode = new Date(res.result.datedeb);
                    if (res.result && res.result.datefin)
                      this.datefinperiode = new Date(res.result.datefin);
                      
                      this.dateParamsForPayslips = {
                          startDatePeriod : this.datedebperiode,
                          endDatePeriod : this.datefinperiode,
                      }
                  });
                }
              });

            }
          }
        });

      });
    });
  }

  setDelegationValues() {
    this.delegationData["DT_DEBUT_CONT"] = this.firstFormGroup.get("dateContSala").value;
  }

  // tentative de préchargement du gif 'horloge'
  pload(...args: any[]):void{
    for (var i = 0; i < args.length; i++) {
      this.imgs[i] = new Image();
      this.imgs[i].src = args[i];
      console.log('loaded: ' + args[i]);
    }
  }
  confirmAbandon(){
    window['tryga']('send', 'event', 'dossier', 'annuler', '', '');
    if(this.dossier){
      this.router.navigateByUrl("/dossier");
    }else{
      const dialogRef = this.dialog.open(MessConfirmAbandon, {
        width: '100%',
        panelClass:'abandon-dialog',
      });
    }
  }

  triBulletin(dossier:any){
    console.log('DOSSIER TRI BULLETIN', dossier)
    let bulletinTri = [];
    if(dossier.bulletinSalaire && dossier.bulletinSalaire.length > 0){
      bulletinTri = dossier.bulletinSalaire
        .sort((a, b) => {
            return a.datedebutbs > b.datedebutbs ? 1 : -1
        })
        .sort((a, b) => {
          if (a.datedebutbs == b.datedebutbs) {
            return a.typepage == "P" ? -1 : 1
          }
          return 0
        })
        .map((element) => [element]);

      this.fichiersBS = bulletinTri;
      let i = 0
      this.fichiersBS.forEach((element)=> {
        let numIns = null;
        if(element[0].erreur){
          numIns = this.getTypeError(element);
          if(element[0].erreur == "Oups, ce bulletin de salaire ne correspond pas à la période demandée." && element[element.length-1].datedebutbs ){
            let datedebbs = element[element.length-1].datedebutbs.split('T')[0].split('-')
            let annee = datedebbs[0]
            let mois = datedebbs[1]
            element[0].erreur =   "Oups, ce bulletin de salaire daté du "+mois+"/"+annee+" ne correspond pas à la période demandée."
          }
        }
        
        let info = {
          count : element.length,
          nom : element[0].nom,
          datecreation : element[0].datecreation,
          dossierid: element[0].dossier_ID,
          datefinreco : element[0].datefinreco ? element[0].datefinreco : '',
          datereco : element[element.length-1].datereco ? element[element.length-1].datereco : '',
          incorrect : 0,
          datedebutbs : element[element.length-1].datedebutbs ? element[element.length-1].datedebutbs:'',
          valide : 1,
          url : element[0].url,
          erreur : element[0].erreur ? element[0].erreur : null,
          instruction : false,
          numInstruction : numIns
        }
        element.splice(0, 0, info);
        element.forEach((bs, index) => {
          if(bs.valide != 1 && index != 0){
            element[0].incorrect++;
            element[0].valide = 0;
          }
        });
        if(element[1].typepage && element[1].typepage === "S" && i !=0){
          if(this.fichiersBS[i-1][0].datedebutbs == element[0].datedebutbs){
              if(this.fichiersBS[i-1]['BsSecondaires']) {
                this.fichiersBS[i-1]['BsSecondaires'].push(element)
              }
              else {
                this.fichiersBS[i-1]['BsSecondaires'] = [element]
              }
          }else{
            element[1].typepage ="P"
          }
        }else if(element[1].typepage && element[1].typepage === "S" && i ==0){
            element[1].typepage ="P"
        }
        i++
      });
      this.cdf.detectChanges()
    }
  }
  getTypeError(error){
    let num = null;
      switch (error[0].erreur) {
        case "Oups, ce document est illisible ou ne correspond pas à un bulletin de salaire.":
          num=1;
          break;
      case "Oups, ce bulletin de salaire semble appartenir à une autre personne ou un autre contrat de travail.":
        num=2;
        break;
      case "Oups, ce bulletin de salaire ne correspond pas à la période demandée.":
        num=3;
        break;
      case "Ce bulletin n'a pas de période reconnue":
        num=3;
      break;
      case "Oups, ce document a déjà été chargé et se retrouve en double":
        num=5;
        break;
      case "Oups, la page principale de ce bulletin de salaire semble manquer.":
        num=6;
        break;
        default:
        num=null;
          break;
      }

    return num;
  }

  submitCreatDoss() {
    let dossier = this.firstFormGroup.getRawValue();
    let effectifUpload;
    let effectifEntete;
    let listEffectifs = [];
    
    if (this.entrepriseInfo && this.siretIsValid) {
        for (const [key, value] of Object.entries(this.effectifTranches)) {
            if (key == this.entrepriseInfo.tranche_effectif) {
                this.entrepriseInfo.tranche_effectif = value;
            }
        }

        this.effectifValues.forEach(effectif => {
            let parsedValues = effectif.Value.split("a");
            if (parsedValues.length > 1) {
                let minMax = {
                    min : parsedValues[0],
                    max : parsedValues[1]
                }
                listEffectifs.push(minMax);
            } else {
                if (effectif.Value.includes("plus")) {
                    parsedValues = effectif.Value.split("plus");
                    let min = {
                        min : parsedValues[0]
                    }
                    listEffectifs.push(min);
                }
            }
        });
        
        effectifUpload = parseInt(this.entrepriseInfo.tranche_effectif);
        
        listEffectifs.forEach((effectif, index) => {
            if (effectif.max && effectif.min) {
                if (effectifUpload >= effectif.min && effectifUpload <= effectif.max) {
                    effectifEntete = this.effectifValues[index];
                }
            } else if (effectif.min) {
                if (effectifUpload >= effectif.min) {
                    effectifEntete = this.effectifValues[index];
                }
            }
        });
    }
    console.log("DOSSIER ENVOYE :", dossier)
    this.subscribe['dateperiode'] = this.appService.getDatePeriode(this.firstFormGroup.get("dateContSala").value, this.firstFormGroup.get("postSala").value, this.firstFormGroup.get("dateContSortieSala").value, this.firstFormGroup.get("motifSala").value, this.firstFormGroup.get("dateRupt").value, this.firstFormGroup.get("maladieSala").value, this.firstFormGroup.get("dateMaladieSala").value).subscribe((res) => {
      if (res.result && res.result.datedeb)
        this.datedebperiode = new Date(res.result.datedeb);
      if (res.result && res.result.datefin)
        this.datefinperiode = new Date(res.result.datefin);
      if(this.dossier === ""){
        this.subscribe['assdoss'] = this.appService.addDossier(dossier.civiliteSala, (dossier.siret ? dossier.siret : ""), dossier.firstnameSala, dossier.nameSala, dossier.nameEntSala, dossier.postSala,
          dossier.dateContSala, this.datedebperiode, dossier.dateContSortieSala, dossier.typeSala,
          dossier.statutSala, dossier.motifSala, /*dossier.suspSala, suspPeriode,*/ dossier.maladieSala, dossier.dateMaladieSala, this.datefinperiode,
          dossier.contRompu, dossier.dateRupt, dossier.nomDateRupt, dossier.boolRupt, this.couponId,
          dossier.pseudoSalarie, dossier.pseudoEntreprise, dossier.isAnonyme
          ).subscribe((res) => {
            this.dossier = res.result.dossier;
            this.dossier.datedebut = dossier.dateContSala;
            this.dossier.datesortie = dossier.dateContSortieSala;
            this.dossier.poste = dossier.postSala;
            this.dossier.motifsortie = dossier.motifSala;
            this.stateService.updateDossier(this.dossier);
            this.titleService.setTitle("Rupture by Cobham - dossier "+this.dossier.displayID+ " - "+this.dossier.prenom+" "+this.dossier.nom);
			
            if (this.entrepriseInfo && effectifEntete && this.siretIsValid) {
                this.appService.addDossierEntete(this.dossier.id, {"EFFECT_EMP" : effectifEntete.Value}).subscribe((res) => {
                    console.log("ADD ENTETE :", res)
                });
            }

            if (this.dataFromUploadedFile && Object.keys(this.dataFromUploadedFile).length > 0) {
                this.appService.processRecoResponse(this.dossier.id, this.dataFromUploadedFile).subscribe((res) => {
                    this.forceReloadPayslips();
                    this.fichiersCreation = [];
                    this.dataFromUploadedFile = {};
                    this.myStepper.next()
                    this.nextButtonIsDisabled = false;
                });
            } else {
                this.myStepper.next()
                this.nextButtonIsDisabled = false;
            }
                
            // 1645 après la création du dossier, on initialise les services à activer ou non
            this.subscribe['json1'] = this.httpClient.get('assets/content-dossierpost.json?v='+window['cobham_version']).subscribe((res)=>{
                let services = res['services']
                services.forEach((service) => {
                    this.appService.updateService(this.dossier.id, service,dossier.boolRupt == "TRUE" ? 'Diag' : 'Simul', (service.actif && service.selected) ? 'ADD' : 'REMOVE').subscribe((res)=>{})
                })
            })
        });
      }
      else{
        this.subscribe['updatedoss'] = this.appService.updateDossierDelegation(this.dossier.id, dossier.civiliteSala,
            dossier.firstnameSala, dossier.nameSala, dossier.nameEntSala, dossier.postSala,
            dossier.dateContSala, this.datedebperiode, dossier.dateContSortieSala, dossier.typeSala,
            dossier.statutSala, dossier.motifSala, /*dossier.suspSala, suspPeriode,*/ dossier.maladieSala, dossier.dateMaladieSala, this.datefinperiode,
            dossier.contRompu, dossier.dateRupt, dossier.nomDateRupt, dossier.boolRupt,
            (dossier.siret ? dossier.siret : ""), dossier.pseudoSalarie, dossier.pseudoEntreprise, dossier.isAnonyme
          ).subscribe((res) => {
            this.dossier = res.result.dossier;
            this.dossier.datedebut = dossier.dateContSala;
            this.dossier.datesortie = dossier.dateContSortieSala;
            this.dossier.poste = dossier.postSala;
            this.dossier.motifsortie = dossier.motifSala;

            if (this.entrepriseInfo && effectifEntete && this.siretIsValid) {
                this.appService.addDossierEntete(this.dossier.id, {"EFFECT_EMP" : effectifEntete.Value}).subscribe((res) => {
                    console.log("ADD ENTETE :", res)
                });
            }

            if (this.dataFromUploadedFile && Object.keys(this.dataFromUploadedFile).length > 0) {
                this.appService.processRecoResponse(this.dossier.id, this.dataFromUploadedFile).subscribe((res) => {
                    this.forceReloadPayslips();
                    this.fichiersCreation = [];
                    this.dataFromUploadedFile = {};
                    this.myStepper.next()
                    this.nextButtonIsDisabled = false;
                });
            } else {
                this.myStepper.next()
                this.nextButtonIsDisabled = false;
            }
            this.subscribe['json1'] = this.httpClient.get('assets/content-dossierpost.json?v='+window['cobham_version']).subscribe((res)=>{
                let services = res['services']
                services.forEach((service) => {
                    this.appService.updateService(this.dossier.id, service,dossier.boolRupt == "TRUE" ? 'Diag' : 'Simul', (service.actif && service.selected) ? 'ADD' : 'REMOVE').subscribe((res)=>{})
                })
            })
            this.consolidationBS(this.myStepper, false);
        });
      }
    });
  }

    uploadFileCreation(event) {
        this.creationEvent = event;
        this.uploadingFile = true;
        console.log("uploadFileCreation event : ", event)
        if(this.promise && this.promise['uploadfile3'] && this.promise['uploadfile3'].length > 0){
            return
        }
        this.promise['uploadfile3'] = []
        let reco = []
        for(let i=0;i<event.length;i++){
            const element = event[i];
            reco[i] = {
                datereco : "",
                state: `En cours de téléchargement.`,
                nom : element.name,
                valide: -1,
                failed: false,
                url:""
            }

            if(element.size >= this.sizemaxFile){
                reco[i].state = "Votre fichier " +element.name+" dépasse la taille autorisée de "+(this.sizemaxFile/(1024*1024)).toFixed(2) +"Mo, merci de scanner vos documents en 2 ou 3 lots afin de générer un fichier plus petit." 
                reco[i].failed = true
                this.fichiersCreation.push(reco)
            }
            else {
            //if(element.size < this.sizemaxFile){
                this.promise['uploadfile3'].push(
                    this.appService.uploadDocument(element, "").toPromise().then(res => {
                        console.log("après upload document", res)
                        this.required = [];
                        reco[i].url = res.url ? res.url : "";
                        reco[i].nom = res.filename ? res.filename : element.name;
                        reco[i].id = res.url ? res.url : "";
                        reco[i].state = res.error_reco ? "Téléchargement échoué" : "Téléchargement réussi, validation en cours 30%";
                        reco[i].erreur = res.error ? res.error : "";
                        reco[i].nbBulletin = res.validation.result["nombre de Bulletin(s) de salaire"] ? res.validation.result["nombre de Bulletin(s) de salaire"] : "";
                        if (!res.invalide && !res.error && !res.error_reco) {
                            let arrayCode = ["CIV_SAL", "NOM_COMPL_SAL", "NOM_EMP", "SIRET", "DT_ENT_BS", "DT_S_BS", "DT_ANC_BS"]; // "DT_SORT_BS"
                            let values = this.getDataFromRecoResponse(arrayCode, res);
                            this.dataFromUploadedFile = {
                                "directory" : res.directory,
                                "filename" : res.filename,
                                "url" : "/" + res.url,
                                "validation" : res.validation,
                                "result" : res
                            }   

                            if (values["CIV_SAL"]) {
                                let civilite = values["CIV_SAL"];

                                if (civilite == "Mr" || civilite == "Monsieur") {
                                    values["CIV_SAL"] = "M";
                                } else if (civilite == "Mrs" || civilite == "Madame") {
                                    values["CIV_SAL"] = "F";
                                } else {
                                    values["CIV_SAL"] = "";
                                }
                            }

                            if (values["NOM_COMPL_SAL"]) {
                                let identityValues = values["NOM_COMPL_SAL"].split(" ");
                                identityValues = identityValues.filter(n => n);
                                let index = 0;

                                let identity = {
                                    "nom" : identityValues[index],
                                    "prenom" : ""
                                };

                                index++;
                                for (index; index < identityValues.length; index++) {
                                    identity.prenom += identityValues[index];
                                    if (identityValues.length - 1 != index) {
                                        identity.prenom += " "; 
                                    }
                                }

                                values["NOM_COMPL_SAL"] = identity;
                            }

                            this.dossierCreationData = values;

                            this.firstFormGroup.get("civiliteSala").setValue(values["CIV_SAL"] ? values["CIV_SAL"] : "");
                            this.firstFormGroup.get("firstnameSala").setValue(values["NOM_COMPL_SAL"] ? values["NOM_COMPL_SAL"].prenom : "");
                            this.firstFormGroup.get("nameSala").setValue(values["NOM_COMPL_SAL"] ? values["NOM_COMPL_SAL"].nom : "");
                            this.firstFormGroup.get("nameEntSala").setValue(values["NOM_EMP"] ? values["NOM_EMP"] : "");
                            this.firstFormGroup.get("siret").setValue(values["SIRET"] ? values["SIRET"] : "");
                            this.firstFormGroup.get("dateContSala").setValue("");
                            this.firstFormGroup.get("dateContSortieSala").setValue("");
                            
                            if (values["SIRET"]) {
                                if (values["SIRET"].toString().match(this.regexSiret))
                                    this.verifySiren();
                            }

                            try
                            {
                                if (values["DT_ENT_BS"]) {
                                    this.firstFormGroup.get("dateContSala").setValue(this.fromDateToString(values["DT_ENT_BS"]).split('T')[0]);
                                }

                                if (!values["DT_ENT_BS"] && values["DT_ANC_BS"]) {
                                    this.dateAncienneteBS = new Date(this.fromDateToString(values["DT_ANC_BS"].split('T')[0])).toLocaleDateString("fr-FR");
                                }

                                if (values["DT_S_BS"]) {
                                    this.firstFormGroup.get("dateContSortieSala").setValue(this.fromDateToString(values["DT_S_BS"]).split('T')[0]);
                                    this.computeBoolRupt("FALSE")
                                    if (this.firstFormGroup.get("postSala").value == "TRUE") {
                                        this.firstFormGroup.get("postSala").setValue("FALSE");
                                        if (this.svgTogglePostSala) {
                                            this.svgTogglePostSala["positionStart"] = "FALSE";
                                            this.svgTogglePostSala["positionCxButton"] = "14";
                                            this.svgTogglePostSala["fillColorButton"] = "#6016AA";
                                            this.svgTogglePostSala["fillColorBack"] = "#FFF";
                                        }
                                    }
                                }
                            }
                            catch (e) {
                                console.log(e)
                            }

                            if (this.firstFormGroup.get('isAnonyme').value == "TRUE") {
                                this.siretIsValid = false;
                            }
                            console.log("Dossier créé values : ", values);
                        }

                        if(this.waiting != 0)
                            this.percentage(reco[i]);

                        if(res.error_reco){
                            console.log(res.error_reco)
                            if(res.error_reco == "Le service d'Ocr (ABBY) est momentanement indisponible.")
                                this.errorAbbyy = true
                            reco[i].state = res.error_reco;
                            reco[i].failed = true;
                            this.nbEvent--
                            reco.splice(i,1) 
                        }

                        if (i + 1 === event.length && this.errorAbbyy) {
                            let textError = 
                                "Rupture by Cobham rencontre un problème sur l’un de ses serveurs." 
                                + "\n" +
                                "L'équipe technique a été avertie et nous reviendrons vers vous le plus rapidement possible."
                                + "\n\n" + 
                                "Pour tout complément d’informations sur le problème que vous rencontrez, nous vous invitons à nous contacter en envoyant un mail à support@cobham-solutions.com"
                                + "\n\n" + 
                                "L\'équipe Rupture by Cobham.";
                            this.openAbbyyErrorDialogAndSendMail("Erreur Abbyy", "mailBody", textError);
                        }
                    })
                )
            }

            Promise.all(this.promise['uploadfile3']).then((value) => {
                this.promise["uploadfile3"] = [];
                this.afterUploadCreateFinished(reco[i]);
            }).catch((error)=>{
                console.log(error)
            })
        
        }
    }

  removeFileInError(file){
    let index = this.filesInError.indexOf(file)
    if(index > -1)
      this.filesInError.splice(index,1)
  }
  uploadFileComp(event) {
    const element = event[0];
    this.subscribe['uploadfile'] = this.appService.uploadDocument(element, this.dossier.id).subscribe((res) => {

      this.fichierscomp.push(res);
    });
  }
  async checkDossierForm() {
    this.nextButtonIsDisabled = true;
    window['tryga']('send', 'event', 'dossier', 'suivant_creation_dossier_salarie', '', '');
    let form = this.firstFormGroup.getRawValue();
    this.required = [];

    if (this.siretIsValid && !this.buttonSiretIsClicked) {
        await new Promise(resolve => this.getDataFromSiret().subscribe((result) => {
            if (result["error"]) {
                if (!result["error"].includes("503")) {
                    // this.required["siret"] = true
                    resolve(this.entrepriseInfo = "");
                }
            } else {
                // if (result.nom_entreprise != form.nameEntSala) {
                //     this.required["nameEntSalaCheck"] = true;
                // } else {
                    resolve(this.entrepriseInfo = result);
                // }
            }
        }))
    }

    if (form.isAnonyme == "FALSE") {
        if (!form.siret || !form.siret.toString().match(this.regexSiret)) {
            // this.required['siret'] = true;
        }
        if (!form.firstnameSala) 
            this.required['firstnameSala'] = true;
        if (!form.nameSala) 
            this.required['nameSala'] = true;
        if (!form.nameEntSala)
            this.required['nameEntSala'] = true;
    } else {
        if (!form.pseudoSalarie) {
            this.required["pseudoSalarie"] = true;
        }
        if (!form.pseudoEntreprise) {
            this.required["pseudoEntreprise"] = true;
        }
    }

    if(this.dateDiffInDays(new Date(form.dateContSala), new Date()) < 30) {
        this.required["invalidDateContSala"] = true;
        this.required['dateContSala'] = true;
    }

    if (!form.civiliteSala) 
        this.required['civiliteSala'] = true;
    if (!form.postSala) 
      this.required['postSala'] = true;
    if (!form.dateContSala) 
      this.required['dateContSala'] = true;
    if (!form.typeSala) 
      this.required['typeSala'] = true;
    //if (!form.suspSala) 
    //  this.required['suspSala'] = true;

    if (form.suspSala == "TRUE"){
      //TODO required date début et fin
    }
    if(form.dateContSala){
      let dateNow = new Date()
      
      let dateContSalaSplit = form.dateContSala.split('-')
      if(new Date(dateContSalaSplit[0], parseInt(dateContSalaSplit[1])-1, dateContSalaSplit[2]) > dateNow){
        this.required['dateContSala'] = true
        this.dateContSalaFalse = true
      }else{
        this.dateContSalaFalse = false

      }
    }

    this.dateRuptFalse = false;
    this.dateSortieFalse = false;
    if (form.dateContSala && form.dateRupt) {
      let entree = new Date(form.dateContSala);
      let rupt = new Date(form.dateRupt);
      if (form.dateContSortieSala) {
        let sortie = new Date(form.dateContSortieSala);
        if (entree > rupt || rupt > sortie) {
          this.required['dateRupt'] = true;
          this.dateRuptFalse = true;
        }
      } else {
        if (entree > rupt) {
          this.required['dateRupt'] = true;
          this.dateRuptFalse = true;
        }
      }
    }
    if (form.dateContSala && form.dateContSortieSala) {
      let entree = new Date(form.dateContSala);
      let sortie = new Date(form.dateContSortieSala);
      if (entree > sortie){
        this.required['dateContSortieSala'] = true;
        this.dateSortieFalse = true;
      } 
    }

    if (form.postSala == "FALSE" && (form.motifSala == "LICENCIEMENT PERS" || form.motifSala == "LICENCIEMENT ECO") && !form.maladieSala) {
      this.required['maladieSala'] = true;
    }

    if (form.postSala == "FALSE" && (form.motifSala == "LICENCIEMENT PERS" || form.motifSala == "LICENCIEMENT ECO") && form.maladieSala == 'TRUE' && !form.dateMaladieSala) {
      this.required['dateMaladieSala'] = true;
    }

    if (!form['statutSala'] && this.map_contrat_statut.hasOwnProperty(form.typeSala) && this.map_contrat_statut[form.typeSala].length) {
      this.required['statutSala'] = true
    }
    
    if (form.boolRupt == "TRUE") {
      if (!form['motifSala'] && this.map_contrat_motif.hasOwnProperty(form.typeSala) && this.map_contrat_motif[form.typeSala].length) {
        this.required['motifSala'] = true
      }
      if (!form['dateRupt'] && !["","RC"].includes(form['motifSala'])) {
        this.required['dateRupt'] = true;
      }
    }
    if (form.postSala == "FALSE") {
      if (!form['dateContSortieSala']){
        this.required['dateContSortieSala'] = true;
      }
    }

    console.log("REQUIRED ::: ", this.required);

    let testDateErr = this.testDateErr()
    if( !testDateErr && (! this.required || Object.keys(this.required).length === 0) && 
        this.myStepper.selectedIndex == 1) 
    {
        this.submitCreatDoss()
    } else {
        this.nextButtonIsDisabled = false;
    }
  }
  testDateErr(){
    this.dateErr = []
    let dateRupt = (<HTMLFormElement>document.querySelector('input[formControlName="dateRupt"]'));
    let dateContSala = (<HTMLFormElement>document.querySelector('input[formControlName="dateContSala"]'));
    let dateContSortieSala = (<HTMLFormElement>document.querySelector('input[formControlName="dateContSortieSala"]'));
    let dateMaladieSala = (<HTMLFormElement>document.querySelector('input[formControlName="dateMaladieSala"]'));
    [dateRupt,dateContSala, dateContSortieSala, dateMaladieSala].forEach(dt =>{
      if(dt && dt.validity.badInput)
        this.dateErr[dt.getAttribute('formcontrolname')] = true
      })
    // Si aucune date en erreur alors return false
    if(this.dateErr && this.dateErr.length != 0){
      return true;
    }
    return false;
  }
  changeInput(input){
    let form = this.firstFormGroup.getRawValue()

    // cas rupture conventionnelle : date de sortie = date rupture --> annulé COB-985
    if (form.motifSala == "RC") {
      // if (form.dateContSortieSala && form.dateRupt) {
      //   if (form.dateContSortieSala != form.dateRupt) {
      //     this.firstFormGroup.get("dateRupt").setValue(form.dateContSortieSala);
      //   }
      // } else if (form.dateContSortieSala && !form.dateRupt) {
      //   this.firstFormGroup.get("dateRupt").setValue(form.dateContSortieSala);
      // } else if (!form.dateContSortieSala && form.dateRupt) {
      //   this.firstFormGroup.get("dateContSortieSala").setValue(form.dateRupt);
      // }
      this.firstFormGroup.get("dateRupt").setValue(this.firstFormGroup.get("dateContSortieSala").value);
      this.firstFormGroup.get("dateRupt").disable({ onlySelf: true });
    } else if (form.boolRupt == "TRUE") {
      this.firstFormGroup.get("dateRupt").enable({ onlySelf: true });
    }

    // Si valeur presente, suppression dans this.required
    if(form && form[input] && this.required && this.required[input]){
      this.required[input] = null
    }
    this.testDateErr()
    if(input == "typeSala"){
      if(form && form['typeSala'] != "CDI" && form['typeSala'] != "CDD" && this.required && this.required['statutSala']){
        this.required['statutSala'] = null
      }
    }

    if (input === "siret") {
        let siret = this.firstFormGroup.get("siret").value;
        if (siret != null) {
            siret = siret.toString();
    
            if (siret && siret.match(this.regexSiret)) {
                this.verifySiren();
            } else {
                this.siretIsValid = false;
            }
        } else {
            this.siretIsValid = false;
        }
    }

    this.cdf.detectChanges()
  }

    removeBulletinCreation() {
        this.fichiersCreation = [];
    }

  removeBulletin(fichier: any){
    let listIds = [];
    fichier.forEach((element, index)=> {
      if(index > 0)
        listIds.push(element.id);
    })
    this.subscribe['bulletinremove'] = this.appService.removeBulletin(listIds, false).subscribe((res)=> {
      let idDel = "";
      this.fichiersBS.forEach((element, index) => {
        if(element[0].datecreation == fichier[0].datecreation)
          idDel = index;
      });
      this.subscribe['dossier2'] = this.appService.getDossierById(this.dossier.id).subscribe((res) => {
        if(res.result.error && res.result.code){
          this.errorHandling(res.result)
        }else {

          if(this.fichiersBS[idDel].BsSecondaires){
            this.fichiersBS[idDel] = this.fichiersBS[idDel].BsSecondaires
          }else{
            
            this.fichiersBS.splice(idDel, 1);
          }
          this.stateService.updateDossier(res.result.datas[0]);
        }
      })
    })
  }
    showFile(file:string){

        let fileurl = ''
        let pdfOk = true;
        let pdfExt : RegExp = /\.pdf$/;
        let page;

        if (file[1]) {
            if(file[1]['urlfront']){
                fileurl = file[1]['urlfront']
            }else{
                fileurl = file[0]['url']
            }
            pdfExt.test(file[0]['nom']) ? pdfOk = true : pdfOk = false;
            page = file[1]['page'] ? file[1]['page'] : 1;
        } else {
            if (file["urlfront"]) {
                fileurl = file["urlfront"];
            } else {
                fileurl = file["url"];
            }
            pdfExt.test(file['nom']) ? pdfOk = true : pdfOk = false;
            page = file['page'] ? file['page'] : 1;
        }

        //pdfExt.test(fileurl) ? pdfOk = true : pdfOk = false;
        const dialogRef = this.dialog.open(ShowFileDialog, {
            width: '100%',
            panelClass:'viewpdf-dialog',
            data: {
                url: fileurl,
                pdf: pdfOk,
                name: file[0] ? file[0]['nom'] : file['nom'],
                page : page
            }
        });
    }

  percentage(fichier){
      setTimeout(()=>{
        this.waiting -= 200;
        let perc = (((environment.waiting - this.waiting) / environment.waiting) * 70)+30;
        if(perc > 100){
          perc = 100;
        }
        if(fichier.failed == false){
          fichier.state = "Téléchargement réussi, validation en cours "+perc+"%";
        }
        this.percentage(fichier);
      }, 200);
  }

  afterDownloadFinished(fichiers, dossier){
    this.nbEvent--;
   console.log("fichiers", fichiers)
   // console.log("dossier", dossier)
    fichiers.forEach(fichier => {
      if(fichier.failed == false){

          dossier.datas[0].bulletinSalaire.forEach((element, index) => {
            //console.log("FICHIER.ID, ELEMENT.URL",fichier.id, element.url)
            if(fichier.id === element.url){
              fichier.state = "Lecture réussie 100%";
              if(dossier.datas[0].bulletinSalaire[index] && dossier.datas[0].bulletinSalaire[index].erreur){
                fichier.error =  dossier.datas[0].bulletinSalaire[index].erreur;
                fichier.numInstruction = this.getTypeError(fichier.error);
                fichier.instruction = false,
                this.fichiersBS.splice(0, 0, fichier);
              }
              
              _.groupBy(dossier.datas[0].bulletinSalaire, "nom");
              // if(this.nbEvent <= 0){
                // this.triBulletin(dossier.datas[0]);
              // }
              this.waiting = environment.waiting;
            }
          });
        }else{
          this.filesInError.push(fichier)
        }
        console.log("fichiersBS",this.fichiersBS)
    });
    console.log("%c ErroR Abbyy ==> "+this.errorAbbyy, "color:red;")
    if(this.errorAbbyy){
      this.appService.sendMailErrorAdmin(this.dossier.id).subscribe(res => {
        console.log(res)
      })
      this.errorAbbyy = false;
    }

    this.stateService.updateDossier(dossier.datas[0]);
    this.erreurperiode = dossier.datas[0].erreurperiode;
    console.log("DOSSIER DATAS =>", dossier.datas[0])
    this.promise['uploadfile2'] = []
  }

    afterUploadCreateFinished(fichier) {
        this.nbEvent--;
        let array = [];
        array.push(fichier);
        this.uploadingFile = false;
        if(fichier.failed == false) {
            this.fichiersCreation = [];
            if (fichier.erreur) {
                fichier.valide = 0;
                if (fichier.erreur == "Oups, ce document est illisible ou ne correspond pas à un bulletin de salaire.") {
                    fichier.erreur = "Le fichier ne contient pas de bulletin de salaire."
                } else if (fichier.erreur == "Une erreur est survenue lors de la reconnaissance du fichier.") {
                    fichier.erreur = "Le fichier contient un ou plusieurs bulletins de salaire illisibles."
                }
            
            } else {
                fichier.valide = 1;
            }
            this.fichiersCreation.push(fichier);
        } else {
            this.filesInError.push(fichier)
        }
        console.log("fichierCreation", this.fichiersCreation)
    }

  toggleChip(chip, event = null) {
    console.log("Statut:", chip)
    if(!event || event.keyCode == 32){
      if(this.statuts){
        this.statuts.forEach(c => {
          chip.Value !== c.Value ? c.selected = false : c.selected = true;
          if(c.selected){
            this.firstFormGroup.get("statutSala").setValue(c.Value);
            this.changeInput('statutSala')
          }
        });
      }
    }
  }

  toggleChipContrat(chip, event = null) {
    console.log('event contrat', event)
    if(!event || event.keyCode == 32){
      if(this.contrats){
        this.contrats.forEach(c => {
          chip.Value !== c.Value ? c.selected = false : c.selected = true;
          if(c.selected){
            this.firstFormGroup.get("typeSala").setValue(c.Value);
            let replaceStatuts = this.allstatuts.map(statut => {
              if (this.map_contrat_statut.hasOwnProperty(c.Value) && this.map_contrat_statut[c.Value].includes(statut.Value))
                statut['actif'] = true;
              else 
                statut['actif'] = false;
              return statut;
            });
            this.statuts = replaceStatuts;
            this.firstFormGroup.get("statutSala").setValue("");
            let replaceMotifs = this.allmotifs.map(motif => {
              if (this.map_contrat_motif.hasOwnProperty(c.Value) && this.map_contrat_motif[c.Value].includes(motif.Value))
                motif['actif'] = true;
              else 
                motif['actif'] = false;
              return motif;
            });
            this.motifs = replaceMotifs;
            this.firstFormGroup.get("motifSala").setValue("");
            this.changeInput('typeSala')
          }
        });
      }
    }
  }

  toggleChipMotif(chip, event = null) {
    if(!event || event.keyCode == 32){
      if(this.motifs){
        this.motifs.forEach(c => {
          chip.Value !== c.Value ? c.selected = false : c.selected = true;
          if(c.selected){
            this.firstFormGroup.get("motifSala").setValue(c.Value);
            this.changeInput('motifSala')
            if (c.Value == "LICENCIEMENT PERS") {
              this.firstFormGroup.get("nomDateRupt").setValue("DT_LIC_PERS");
            } else if (c.Value == "LICENCIEMENT ECO") {
              this.firstFormGroup.get("nomDateRupt").setValue("DT_LIC_ECO");
            } else if (c.Value == "RC") {
              this.firstFormGroup.get("nomDateRupt").setValue("DT_LIC_RC");
            } else if (c.Value == "DEMISSION") {
              this.firstFormGroup.get("nomDateRupt").setValue("DT_DEM");
            } else /*if (c.Value != "DR")*/ {
              this.firstFormGroup.get("nomDateRupt").setValue("DT_FIN_CONT");
            }
          }
        });
        this.cdf.detectChanges();
      }
    }
  }

  computeBoolRupt(postSalaValue = null) {
    let postSala = postSalaValue;
    if (!postSalaValue) {
      let doss = this.firstFormGroup.getRawValue();
      postSala = doss.postSala;
    }
    if (postSala == "FALSE" && this.firstFormGroup.get("contRompu").value == "FALSE")
        this.firstFormGroup.get("contRompu").setValue("TRUE");
    if (postSala == "FALSE" || this.firstFormGroup.get("contRompu").value == "TRUE") {
      this.firstFormGroup.get("boolRupt").setValue("TRUE");
    } else {
      this.firstFormGroup.get("boolRupt").setValue("FALSE");
    }
  }

  erasePreviousValue(postSalaValue = null) {
    this.firstFormGroup.get("dateContSortieSala").setValue("");
    this.firstFormGroup.get("motifSala").setValue("");
    this.firstFormGroup.get("contRompu").setValue("FALSE");
    this.firstFormGroup.get("dateRupt").setValue("");
    this.firstFormGroup.get("nomDateRupt").setValue("");
    this.firstFormGroup.get("maladieSala").setValue("FALSE");
    this.firstFormGroup.get("dateMaladieSala").setValue("");
    this.computeBoolRupt(postSalaValue);
  }

  checkValidationDossier(stepper: MatStepper, displayErreurOrGoNext = true) {
    if(this.dossier.bulletinSalaire && this.dossier.bulletinSalaire.length >= 1){
      this.subscribe['checkvalidation'] = this.appService.checkValidationDossier(this.dossier).subscribe((data) => {
        this.suivantUploadDisabled = false
        console.log("checkvalid ==>",data)
        if (data.result.dossier.etatvalidation == 4) {
            stepper.selectedIndex = 3;
            this.submitToCobham = true;
            this.erreur = false;
            this.erreurperiode = null;
            // this.appService.processPauseCobham(this.dossier.id).subscribe();
        } else{
          if (displayErreurOrGoNext) {
            window['tryga']('send', 'event', 'dossier', 'telecharger_oups', '', '');
            this.erreur = true; 
          }
          this.erreurperiode = null;
          this.message = data.result.dossier.erreur;
          if(data.result.dossier.erreurperiode)
            this.erreurperiode = data.result.dossier.erreurperiode;

          this.stateService.updateDossier(data.result.dossier);
        }
      });
    }
    else if (displayErreurOrGoNext) {
      this.erreur = true;
      this.message = ["Merci de télécharger les bulletins de salaire de votre client, avant de passer à l’étape suivante."];
    }
    this.cdf.detectChanges()
  }


  changeEtatValidationDossier(stepper: MatStepper, iddossier, etat) {
    this.appService.changeEtatValidationDossier(iddossier, etat).subscribe((data) => {console.log('iciiiiiii',data)});
    if(etat < 4){
      stepper.next();
    }
    
    if (etat == 2) {
      this.erreur = false;
      window['tryga']('send', 'event', 'dossier', 'suivant_telecharger_oups_bulletins_salaire', '', '');
    }
    
      if (etat == 3) {
        window['tryga']('send', 'event', 'dossier', 'suivant_verification', '', '');
      }
    if(etat==4) {
        window['tryga']('send', 'event', 'dossier', 'envoyer_a_cobham', '', '');

        this.consolidationBS(stepper, false, true);
    }
  }

  displayCalcul(calculName = "",display = true) {

    if(display){
      this.calcul = true;
      this.currentCalcul.setValue(calculName);
      (<HTMLFormElement>document.querySelector('#iframe_container form')).submit();
    }
    else
      this.calcul = false;
  }

  quitCalcul(action) {
    let frame = <HTMLElement> document.querySelector('#iframe_container iframe');
    frame['contentWindow'].postMessage({'action': 'trigger-save', 'do-after': action},this.BOCC_URL);
  }

  computeStrCalculResult() {
    let year = false, month = false, day = false;
    this.dossier.entete.forEach(entete => {
      if (entete.parametre && entete.parametre.code == 'DR_ANC_ARRONDI[0]') {
        year = entete.valueint;
      } else if (entete.parametre && entete.parametre.code == 'DR_ANC_ARRONDI[1]') {
        month = entete.valueint;
      } else if (entete.parametre && entete.parametre.code == 'DR_ANC_ARRONDI[2]') {
        day = entete.valueint;
      }

      if (entete.parametre && entete.parametre.code == 'IND_RUPT') {
        if (entete.value != '')
          this.strICL = entete.value + ' €';
      }
    });
    if (year !== false && month !== false && day !== false) {
      this.strAnciennete = (year !== 0 ? (year + ' an' + (year > 1 ? 's' : '')) : '') + (year !== 0 && month !== 0 ? ' et ' : '') + (month !== 0 ? month + ' mois' : '');
    }
  }

  computeInputWithUnitFocus(event) {
    if (event.type == 'blur') {
      event.target.parentNode.className = 'input-with-unit';
    } else if (event.type == 'focus') {
      event.target.parentNode.className = 'input-with-unit focus';
    }
  }

  consolidationBS(stepper: MatStepper, displayErreurOrGoNext = true, disableSuivantBtn = false){
    if (disableSuivantBtn)
      this.suivantUploadDisabled = true
    if (displayErreurOrGoNext == true) {
         window['tryga']('send', 'event', 'dossier', 'suivant_telecharger_bulletins_salaire', '', '');
    }
    if(this.subscribe && this.subscribe['consolidation']){
      this.subscribe['consolidation'].unsubscribe()
    }
    this.subscribe['consolidation'] = this.appService.consolidationBS(this.dossier.id).subscribe((data) => {
      if(data.result && data.result.bulletinSalaire){
        this.consolid = true;
        this.dossier.consolid = true;
        this.dossier.bulletinSalaire = data.result.bulletinSalaire
        this.stateService.updateDossier(this.dossier);
        this.checkValidationDossier(stepper, displayErreurOrGoNext);
      }
    });
  }

  ngOnDestroy(){
    this.titleService.setTitle("Rupture by Cobham");
    this.cdf.detach()
    for(let element in this.subscribe){
        this.subscribe[element].unsubscribe();
        this.subscribe[element] = null;
    }
  }

  initFormWithEntete() {
    if("entete" in this.dossier) {
      this.dossier['entete'].forEach(entete => {
        if(entete.parametre.code.match(/BOOL_MALADIE_LIC/))
          this.firstFormGroup.get("maladieSala").setValue(entete.value == '1' || entete.value ==  'TRUE' ? 'TRUE' : 'FALSE')
        if(entete.parametre.code.match(/DT_ARRET_TRAV/) && entete.valuedate)
          this.firstFormGroup.get("dateMaladieSala").setValue(entete.valuedate.split('T')[0]); 
        if(entete.parametre.code.match(/BOOL_CONT_ROMPU/))
          this.firstFormGroup.get("contRompu").setValue(entete.value == '1' || entete.value ==  'TRUE' ? 'TRUE' : 'FALSE');
        if(entete.parametre.code.match(/DATE_RUPT/) && entete.valuedate)
          this.firstFormGroup.get("dateRupt").setValue(entete.valuedate.split('T')[0]);
        if(entete.parametre.code.match(/PARAM_RUPT/)){
          console.log("%c IL EXISTE ENCORE UN PARAM_RUPT !!!!", 'color:red;')
          this.firstFormGroup.get("nomDateRupt").setValue(entete.value ? entete.value : "");
        }
        if(entete.parametre.code.match(/BOOL_RUPT/)){
          this.firstFormGroup.get("boolRupt").setValue(entete.value == '1' || entete.value ==  'TRUE' ? 'TRUE' : 'FALSE');
        }
      });
    }
  }

  /*removeSuspPeriode(val) {
    if (this.maxSuspPeriodeIndex > 0) {
      if (val != this.maxSuspPeriodeIndex) {
        for (let i = val; i < this.maxSuspPeriodeIndex; i++) {
          this.firstFormGroup.removeControl('suspPeriodeDebut'+i);
          this.firstFormGroup.removeControl('suspPeriodeFin'+i);
          this.firstFormGroup.addControl('suspPeriodeDebut'+i,new FormControl(this.firstFormGroup.get('suspPeriodeDebut'+(i+1)).value));
          this.firstFormGroup.addControl('suspPeriodeFin'+i,new FormControl(this.firstFormGroup.get('suspPeriodeFin'+(i+1)).value));
        }
      }
      this.firstFormGroup.removeControl('suspPeriodeDebut'+this.maxSuspPeriodeIndex);
      this.firstFormGroup.removeControl('suspPeriodeFin'+this.maxSuspPeriodeIndex);
      this.maxSuspPeriodeIndex--;
    }
  }
  addSuspPeriode() {
    this.maxSuspPeriodeIndex++;
    this.firstFormGroup.addControl('suspPeriodeDebut'+this.maxSuspPeriodeIndex, new FormControl(null));
    this.firstFormGroup.addControl('suspPeriodeFin'+this.maxSuspPeriodeIndex, new FormControl(null));
  }
  initSuspPeriode() {
    if (this.dossier.suspendu) {
      if("entete" in this.dossier) {// et si dossier suspendu
        this.dossier['entete'].filter(entete => entete.parametre.code.match(/SUSP_PERIODE\[\d+\]\[[01]\]/)).forEach(entete => {
          let tempSuspPeriode = [...entete.parametre.code.matchAll(/SUSP_PERIODE\[(\d+)\]\[([01])\]/g)][0];
          let indexSuspPeriode = tempSuspPeriode[1];
          let suspPeriodeDebutOuFin = tempSuspPeriode[2] == '0' ? 'Debut' : 'Fin';
          this.firstFormGroup.addControl('suspPeriode'+suspPeriodeDebutOuFin+indexSuspPeriode, new FormControl(entete.valuedate.split('T')[0]));
          if (indexSuspPeriode > this.maxSuspPeriodeIndex) 
            this.maxSuspPeriodeIndex = indexSuspPeriode;
        });
      } else {
        this.setSuspPeriode();
      }
    }
  }
  setSuspPeriode() {
    this.maxSuspPeriodeIndex = 0;
    this.firstFormGroup.addControl('suspPeriodeDebut0', new FormControl(null));
    this.firstFormGroup.addControl('suspPeriodeFin0', new FormControl(null));
  }
  resetSuspPeriode() {
    if (this.maxSuspPeriodeIndex > -1) {
      for (let i = 0; i <= this.maxSuspPeriodeIndex; i++) {
        this.firstFormGroup.removeControl('suspPeriodeDebut'+i);
        this.firstFormGroup.removeControl('suspPeriodeFin'+i);
      }
    }
    this.maxSuspPeriodeIndex = -1;
  }
  getArraySuspPeriode() {
    let result = [];
    if (this.maxSuspPeriodeIndex >= 0) {
      for (let i = 0; i <= this.maxSuspPeriodeIndex; i++) {
        result.push([this.firstFormGroup.get('suspPeriodeDebut'+i).value,this.firstFormGroup.get('suspPeriodeFin'+i).value]);
      }
    }
    return result;
  }*/

  checkInputFormat(e, field) {
    if (field == 'nameSala') {
      let value = e.target.value.split(' ').map(x => {
        //faire un replace des caractères non acceptés ??
        if (x.toLowerCase() == 'de') {
          return x.toLowerCase();
        } else {
          return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
        }
      }).join(' ');
      this.firstFormGroup.controls[field].setValue(value);
    } else if (field == 'firstnameSala') {
      let value = e.target.value.split(' ').map(x => {
        //faire un replace des caractères non acceptés ??
        return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
      }).join(' ');
      this.firstFormGroup.controls[field].setValue(value);
    } else if (field == 'nameEntSala') {
      let value = e.target.value.split(' ').map(x => {
        //faire un replace des caractères non acceptés ??
        return x.toUpperCase();
      }).join(' ');
      this.firstFormGroup.controls[field].setValue(value);
    }
  }

  seeInstruction(instruction){
    const dialogRef = this.dialog.open(InstructionDialog, {
      width: '100%',
      panelClass: instruction.numInstruction == 5 ? 'instruction5-dialog' : 'instruction-dialog',
      data: {numInstruction: instruction.numInstruction,
        datesortie : this.dossier.datesortie,
        datecreation : this.dossier.datecreation,
        datedebperiode : this.datedebperiode
      }
    });
  }

  seeCreditsDetails(){
    const dialogRef = this.dialog.open(DialogCredits, {
      width: '100%',
      // panelClass: 'instruction-dialog',
      panelClass: 'dialog-credits',
      data: this.credits
    });
  }

  seeError(){

    const dialogRef = this.dialog.open(DialogsErrorsComponent, {
      width: '100%',
      panelClass: 'instruction-dialog',
      data: {
        erreurperiode : this.erreurperiode
      }
    })
    dialogRef.beforeClosed().subscribe(res => {
      if(res && res.parcourir){
        let inputUpload = document.getElementById("input-upload-doc")
        inputUpload.click()
      }
    })
  }
  displayStatutLibelle(): string {
    if (this.enteteDoss && this.enteteDoss.STATUT) {
      return this.allstatuts.find(x => x.Value == this.enteteDoss.STATUT).Libelle;
    }
    return "";
  }
  checkCredit() {
    window['tryga']('send', 'event', 'dossier', 'consommer_un_credit', '', '');
    this.uploadBulletin = false
    if (this.toDelegate == true) {
      this.fillDelegationForm = true;
    }
  }
  checkCoupon(codeCoupon){
    if(this.subscribe && this.subscribe['checkCoupon']){
      this.subscribe['checkCoupon'].unsubscribe();
    }
    this.subscribe['checkCoupon'] = this.customerService.checkCoupon(codeCoupon).subscribe((res)=>{
      window['tryga']('send', 'event', 'dossier', 'consommer_un_coupon', '', '');
        if(res && res.result){
          this.couponId = res.result
          this.uploadBulletin = false;
          if (this.toDelegate == true) {
            this.fillDelegationForm = true;
          }
          this.required['codeCoupon'] =false
        }else{
          this.required['codeCoupon'] =true
        }
    })
  }
  modifyValueToggle(event,formGroup, paramForm){
    if(event && event.target && event.target.checked){
        formGroup.get(paramForm).setValue("TRUE")
        if(paramForm === 'postSala')
          this.erasePreviousValue("TRUE")
        if (paramForm === "isAnonyme")
            this.siretIsValid = false;
    }else{
        formGroup.get(paramForm).setValue("FALSE")
        if(paramForm === 'postSala')
            this.computeBoolRupt("FALSE")
        else if (paramForm === 'contRompu')
            this.erasePreviousValue("TRUE")
        if (paramForm === "isAnonyme") {
            if (formGroup.get("siret").value.toString().match(this.regexSiret)) {
                this.verifySiren();
            }
        }
    }
    if(paramForm === 'contRompu')
      this.computeBoolRupt()
}
  redirectionTarif() {
    window['tryga']('send', 'event', 'dossier', 'acheter_des_credits', '', '');
  }

  checkConsomeToken() {
    window['tryga']('send', 'event', 'dossier', 'suivant_saisi_dossier_salarie', '', '');
    this.consumeToken = false;
    this.myStepper.next();
  }

  startUnfolding() {
    this.helperOn = !this.helperOn;
    window['tryga']('send', 'event', 'dossier', 'suivant_debut', '', '');
  }

  prevPaiement() {
    window['tryga']('send', 'event', 'dossier', 'precedent_cobham_paie_validation', '', '');
  }

    preFillInformation() {
        // window['tryga']('send', 'event', 'dossier', 'precedent_cobham_paie_remplissage_donnees', '', '');
        this.consumeToken = true
        this.myStepper.previous();
    }
  
  prevDownloadBulletin(){
    this.myStepper.previous();
    window['tryga']('send', 'event', 'dossier', 'precedent_telecharger_bulletins_salaire', '', '');
  }
  prevDownloadBS(){
    this.myStepper.previous();
    window['tryga']('send', 'event', 'dossier', 'precedent_telecharger_oups_bulletins_salaire', '', '');
  }

  prevVerification(){
    this.myStepper.previous();
    window['tryga']('send', 'event', 'dossier', 'precedent_verification', '', '');
  }

    getDataFromRecoResponse(arrayCode, response){
        let result = {};
        let dataDoss = [];
        let values = response.validation.result.datas[0].VALUES;

        values.forEach(entete => {
            if (entete.VALUE && entete.CODE) {
                dataDoss[entete.CODE] = entete.VALUE;
            }
        });

        for (let i = 0; i < arrayCode.length; i++) {
            if(dataDoss[arrayCode[i]] && !result[arrayCode[i]]){
                result[arrayCode[i]] = dataDoss[arrayCode[i]];
            }
        }

        return result;  
    }

    fromDateToString(date) {
        date = date.replaceAll(".", "-");
        date = new Date(date.toString());
        date.setTime(date.getTime() - (date.getTimezoneOffset() * 60000));
        let dateAsString =  date.toISOString().substr(0, 19);
        return dateAsString;
    }

    verifySiren() {
        this.buttonSiretIsClicked = false;
        let siren = this.firstFormGroup.get("siret").value.toString().slice(0, 9);
        this.subscribe["dataSiren"] = this.appService.verifySiren(siren).subscribe(
            (res) => {
                if (res.result.error) {
                    if (res.result.error.includes("404")) {
                        this.siretIsValid = false;
                        this.errorPappers = false;
                        console.log("Erreur 404");
                    } else if (res.result.error.includes("503")) {
                        this.errorPappers = true;
                        this.siretIsValid = false;
                        console.log("Rien marche");
                    } else { // Peut-être gérer le 401 (token non valide)
                        this.errorPappers = true;
                        this.siretIsValid = false;
                        console.log("Erreur 401 ou autre ?");
                    }
                } else {
                    if (res.result.resultats.length > 0) {
                        this.siretIsValid = true;
                        this.errorPappers = false;
                        console.log("ça marche :: ", res.result.resultats)
                    }
                }
            }
        );
    }

    getDataFromSiret() {
        let siret = this.firstFormGroup.get("siret").value;
        let result = new Subject<any>();
        this.subscribe["dataSiret"] = this.appService.getDataFromSiret(siret).subscribe(
            (res) => {
                result.next(res.result);
            }
        )
        return result.asObservable();
    }

    openDialogSiret() {
        let siret = this.firstFormGroup.get("siret").value;
        this.subscribe["dialogSiret"] = this.appService.getDataFromSiret(siret).subscribe(
            (res) => {
                if (res.result.error) {
                    if (res.result.error.includes("404")) {
                        const dialogRef = this.dialog.open(DialogCommonError, {
                            width: '100%',
                            panelClass:'abandon-dialog',
                            data : "Nous n'avons pas pu trouver d'entreprise liée à ce SIRET (" + siret + ").",
                        });
                    } else if (res.result.error.includes("503")) {
                        const dialogRef = this.dialog.open(DialogCommonError, {
                            width: '100%',
                            panelClass:'abandon-dialog',
                            data : "Il y a eu un problème avec votre recherche.",
                        });
                    }
                } else {
                    this.buttonSiretIsClicked = true;
                    this.entrepriseInfo = res.result;
                    const dialogRef = this.dialog.open(EntrepriseInfoDialog, {
                        width: '100%',
                        panelClass: 'siret-dialog',
                        data : {
                            entreprise : res.result,
                            siret : siret
                        }
                    });
                }
            }
        )
    }

    openAbbyyErrorDialogAndSendMail(subject: string, mailBody: string, textError: string) {
        this.mailService.sendMailToSupport(subject, mailBody).subscribe((res) => {
            const dialogRef = this.dialog.open(DialogCommonError, {
                width: '100%',
                panelClass:'error-dialog',
                data : textError
            });
        });
    }

    dateDiffInDays(dateA, dateB) {
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        const utc1 = Date.UTC(dateA.getFullYear(), dateA.getMonth(), dateA.getDate());
        const utc2 = Date.UTC(dateB.getFullYear(), dateB.getMonth(), dateB.getDate());
    
        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    }

    setErrorHandlingMessage(error: string) {
        this.errorHandlingMessage = error;
    }

    setIsLoading(isLoading: boolean) {
        this.isLoading = isLoading;
    }

    setIsNextButton(isNextButton: boolean) {
        this.isNextButton = isNextButton;
    }

    forceReloadDocuments(dossierId) {
      this.reloadDocuments.next(dossierId);
    }

    forceReloadBoolRupture(boolRupture) {
      this.reloadBoolRupture.next(boolRupture);
    }

    forceReloadPayslips() {
        this.reloadEvent.next();
    }

    forceQuitDelegation() {
      this.quitDelegation();
    }

    setHasAtLeastOnePayslip(value: boolean) {
        this.hasAtLeastOnePayslip = value;
    }

    submitCreditAction(action : string, param) {
        switch(action) {
            case "coupon" :
                this.checkCoupon(param);
                break;
            case "buy-credits":
                this.router.navigate(["/tarifs"], {state: {directDevis: true}});
                break;
            default:
                break;
        }
    }

    getUsersLocale(defaultValue: string): string {
      if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
        return defaultValue;
      }
      const wn = window.navigator as any;
      let lang = wn.languages ? wn.languages[0] : defaultValue;
      lang = lang || wn.language || wn.browserLanguage || wn.userLanguage;
      return lang;
    }

    stopDelegation() {
      let userLocale = this.getUsersLocale("fr");
      let daysDiff = this.dateDiffInDays(new Date(), this.delegationTokenExpirationDate);
      let expireString = "";
      
      if (daysDiff == 1 ) {
        expireString = "demain";
      } else {
        expireString = "dans " + daysDiff + " jours";
      }
      let title = "Quitter Rupture by Cobham ?"
      let body = [];

      body.push("Vous allez quitter Rupture by Cobham. Si vous avez besoin de compléter le dossier et "
        + "d'ajouter de nouveaux documents, merci de cliquer de nouveau sur le lien que vous avez reçu par mail.");

      body.push("Merci de noter que le lien expirera " + expireString + ", soit le " + 
        formatDate(this.delegationTokenExpirationDate, "longDate", userLocale)
        + ". Au-delà de ce délai, il faudra demander à " + this.clientName + " de " + this.company
        + " de vous renvoyer un nouveau lien pour compléter votre dossier.");

      let dialogRef = this.dialog.open(DialogQuestionMessage, {
        width: '50%',
        data: {
            title: title,
            body: body,
        }
      })

      dialogRef.afterClosed().subscribe(result => {
        if (result.positive) {
          this.router.navigateByUrl("/");
        }
      });
    }

    quitDelegation() {
      let userLocale = this.getUsersLocale("fr");
      let daysDiff = this.dateDiffInDays(new Date(), this.delegationTokenExpirationDate);
      let expireString = "";
      
      if (daysDiff == 1 ) {
        expireString = "demain";
      } else {
        expireString = "dans " + daysDiff + " jours";
      }
      let title = "Quitter Rupture by Cobham ?"
      let body = [];

      body.push("Vous allez quitter Rupture by Cobham. Les données que vous avez saisies et les documents"
        + " que vous avez commencé à charger sont mémorisés. ")

      body.push("Si vous avez besoin de compléter le dossier et "
        + "d'ajouter de nouveaux documents, merci de cliquer de nouveau sur le lien que vous avez reçu par mail.");

      body.push("Merci de noter que le lien expirera " + expireString + ", soit le " + 
        formatDate(this.delegationTokenExpirationDate, "longDate", userLocale)
        + ". Au-delà de ce délai, il faudra demander à " + this.clientName + " de " + this.company
        + " de vous renvoyer un nouveau lien pour compléter votre dossier.");

      let dialogRef = this.dialog.open(DialogQuestionMessage, {
        width: '50%',
        data: {
            title: title,
            body: body,
        }
      })

      dialogRef.afterClosed().subscribe(result => {
        if (result.positive) {
          this.router.navigateByUrl("/");
        }
      });
    }

    delegationSkipCreation() 
    {
      this.helperOn = false;
      this.uploadBulletin = false;
      this.consumeToken = true;
    }

    goToContracts() {
      this.setDelegationValues();
      this.contractsScreen = true;
    }

    forceSubmitDelegation() {
      this.changeEtatValidationDossier(this.myStepper, this.dossier.id, 4)
    }
}